var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 13943",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72363",
    d: "M22.81 30a1.3 1.3 0 0 0-1.3 1.3v1.706h-.251a1.255 1.255 0 0 0 0 2.509h.251v2.309h-.251a1.255 1.255 0 1 0 0 2.509h.251v2.208h-.251a1.255 1.255 0 1 0 0 2.509h.251v1.706a1.3 1.3 0 0 0 1.3 1.3h15.458a1.3 1.3 0 0 0 1.3-1.3V31.3a1.3 1.3 0 0 0-1.3-1.3zm10.84 6.022a3.011 3.011 0 1 1-3.011-3.011 3.011 3.011 0 0 1 3.012 3.011zm-3.01 9.536c3.326 0 6.022-1 6.022-1.506 0-1.663-2.7-4.015-6.022-4.015s-6.022 2.352-6.022 4.015c-.001.603 2.696 1.506 6.022 1.506z",
    transform: "translate(-18.038 -27.034)",
    style: {
      fill: "current",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustomer);
export default __webpack_public_path__ + "static/media/ic_customer.bdccd4276031f7dafe7358b883be38bf.svg";
export { ForwardRef as ReactComponent };